export type PropsType = {
    readonly children: JSX.Element;
};

function TableContainer(props: PropsType) {
    return <div className={"table-container"}>{props.children}</div>;
}

export default TableContainer;
